import { makeStyles } from "tss-react/mui"
import { useState } from "react"
import { faBell } from "@fortawesome/pro-light-svg-icons"
import { Box, IconButton, Menu, Stack, Tooltip, Typography } from "@mui/material"
import { useApiQuery } from "../../../../core/api/useApiQuery"
import { fetchNotificationCount, FetchNotificationCountResponse, NotificationQuery } from "./notificationApi"
import { FontAwesomeSvgIcon } from "../NewsBellNavItem/NewsBellNavItem"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { QueryErrorBoundary } from "../../../../core/api/components/QueryErrorBoundary"
import { NotificationPane } from "./NotificationPane"

const useStyles = makeStyles()((theme) => ({
    iconButton: {
        color: theme.palette.tailwind.neutral[500],
    },
    menu: {
        "& .MuiPaper-root": {
            width: "30rem",
            padding: "1rem 1.5rem",
            borderRadius: ".5rem",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        },
    },
    menuTitle: {},
    counterBox: {
        background: "#2196F3",
        borderRadius: "50%",
        color: theme.palette.common.white,
        padding: "0rem 0.406rem",
        fontSize: "0.7rem",
        lineHeight: "1rem",
        letterSpacing: "0.009rem",
        textAlign: "center",
        fontWeight: 500,
        minWidth: "1.5rem",
        height: "1.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    counter: {
        position: "absolute",
        top: "-.25rem",
        right: "-.25rem",
    },
}))

function selectCount(response: FetchNotificationCountResponse) {
    return response.countNotifications
}

type NotificationTopBarProps = Readonly<{
    buttonClassName?: string
    counterClassName?: string
}>

export function NotificationTopBarButton({ buttonClassName, counterClassName }: NotificationTopBarProps) {
    const { classes, cx } = useStyles()

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const { data: notificationCount } = useApiQuery(fetchNotificationCount, {
        queryName: NotificationQuery.NOTIFICATION_COUNT,
        dependencies: {},
        select: selectCount,
        refetchInterval: 60000,
    })

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <LocalizedStrict id="notifications-tooltip-text" attrs={{ title: true }}>
                <Tooltip title="View notifications">
                    <IconButton onClick={handleClick} size="medium" className={cx(classes.iconButton, buttonClassName)}>
                        <FontAwesomeSvgIcon icon={faBell} />
                        {!!notificationCount && (
                            <Box className={cx(classes.counter, classes.counterBox, counterClassName)}>
                                {notificationCount > 99 ? "99" : notificationCount}
                            </Box>
                        )}
                    </IconButton>
                </Tooltip>
            </LocalizedStrict>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                className={classes.menu}
            >
                <Stack spacing="1rem">
                    <LocalizedStrict id="user-home-top-bar-news-notification-menu-title">
                        <Typography variant="body1" fontWeight={500} align="center" className={classes.menuTitle}>
                            Notifications
                        </Typography>
                    </LocalizedStrict>
                    <QueryErrorBoundary>
                        <NotificationPane />
                    </QueryErrorBoundary>
                </Stack>
            </Menu>
        </>
    )
}
